import type { ReactNode, ThHTMLAttributes } from 'react';
import { cn } from '../../lib/utils';

interface TableProps {
  children?: ReactNode;
  className?: string;
}

export function Table({ children, className }: TableProps) {
  return (
    <div className={cn('overflow-x-auto rounded-[1.35rem] border border-[color:var(--surface-line)] bg-[var(--surface-panel)] shadow-[var(--shadow-soft)]', className)}>
      <table className="min-w-full divide-y divide-[color:var(--surface-line)]" style={{ tableLayout: 'fixed' }}>{children}</table>
    </div>
  );
}

export function Thead({ children }: { children: ReactNode }) {
  return <thead className="bg-[var(--surface-panel-strong)]">{children}</thead>;
}

export function Th({ children, className, colSpan, style, ...rest }: TableProps & { colSpan?: number; style?: React.CSSProperties } & Omit<ThHTMLAttributes<HTMLTableCellElement>, 'className' | 'children' | 'style'>) {
  return (
    <th colSpan={colSpan} style={style} className={cn('overflow-hidden text-ellipsis px-4 py-3 text-left text-[0.68rem] font-semibold uppercase tracking-[0.18em] text-[color:var(--ink-soft)]', className)} {...rest}>
      {children}
    </th>
  );
}

export function Tbody({ children }: { children: ReactNode }) {
  return <tbody className="divide-y divide-[color:var(--surface-line)] bg-transparent">{children}</tbody>;
}

export function Tr({ children, className, onClick }: TableProps & { onClick?: () => void }) {
  return (
    <tr className={cn('transition-colors hover:bg-[var(--surface-panel-strong)]/80', onClick && 'cursor-pointer', className)} onClick={onClick}>
      {children}
    </tr>
  );
}

export function Td({ children, className, colSpan, style }: TableProps & { colSpan?: number; style?: React.CSSProperties }) {
  return <td colSpan={colSpan} style={style} className={cn('overflow-hidden text-ellipsis whitespace-nowrap px-4 py-3 text-sm text-[color:var(--ink-base)]', className)}>{children}</td>;
}
